import { useEffect, useState } from "react";
import { Copy, RefreshCw, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, copyOrWarn } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { InstallOptions } from "@/components/InstallOptions";
import { AgentUpdates } from "@/components/AgentUpdates";

export default function Deploy() {
  const { user } = useAuth();
  const [key, setKey] = useState("");
  const [shown, setShown] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => { api.get("/settings/enrollment").then(({ data }) => setKey(data.key)); }, []);

  const regenerate = async () => {
    if (!window.confirm("Générer une nouvelle clé ? Les anciens installateurs ne pourront plus inscrire de machines.")) return;
    const { data } = await api.post("/settings/enrollment/regenerate");
    setKey(data.key);
    setVersion((v) => v + 1);
    toast.success("Nouvelle clé générée");
  };

  return (
    <div className="flex-1 overflow-y-auto px-6 lg:px-10 py-8 max-w-5xl">
      <PageHeader kicker="DÉPLOIEMENT" title="Installer l'agent chez un client" />
      <div className="rounded-lg border border-slate-200 p-5 mb-6">
        <p className="text-xs uppercase tracking-wider text-slate-500 mb-2">Clé d'inscription de votre société</p>
        <div className="flex gap-2 max-w-xl">
          <code data-testid="enrollment-key" className="flex-1 font-mono text-sm bg-slate-50 border border-slate-200 rounded px-3 py-2 truncate">
            {key ? (shown ? key : "•".repeat(key.length)) : ""}
          </code>
          <Button data-testid="toggle-enrollment-key-btn" variant="secondary" size="icon" onClick={() => setShown((s) => !s)} title={shown ? "Masquer" : "Afficher"}>
            {shown ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </Button>
          <Button data-testid="copy-enrollment-key-btn" variant="secondary" size="icon" onClick={() => copyOrWarn(key)}><Copy className="h-4 w-4" /></Button>
          {user?.role === "admin" && <Button data-testid="regenerate-key-btn" variant="secondary" size="icon" onClick={regenerate} title="Régénérer"><RefreshCw className="h-4 w-4" /></Button>}
        </div>
        <p className="text-xs text-slate-500 mt-2">
          Secret de votre société : elle est déjà intégrée dans le fichier à télécharger, vous n'avez pas besoin de la communiquer. En cas de fuite, cliquez sur régénérer.
        </p>
      </div>
      {user?.role === "admin" && <AgentUpdates />}
      <InstallOptions key={version} />
    </div>
  );
}
